<!-- 厦门国际银行-企业微信拉新抽奖活动 -->
<template>
  <div>
    <!-- <MyHeader /> -->
    <div class="xiame-bank-new-guests-have-gifts-records">
      <img
        class="title"
        :src="require(`@/assets/imgs/xiameBankNewGuestsHaveGifts/record1.png`)"
        alt=""
      />
      <div class="content">
        <div class="header">
          <span class="text1">领取日期</span>
          <span class="text2">奖品</span>
          <span class="text3">状态</span>
        </div>
        <!-- <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          @load="myPrize"
          class="list"
        > -->
        <ul class="list">
          <li v-for="item in list" :key="item.id" class="van-hairline--bottom">
            <span class="text1">{{ item.createTimeShow }}</span>
            <span class="text2">
              <span class="van-ellipsis">{{ item.prizeName }}</span>
              <span
                v-if="item.prizeName !== '谢谢惠顾'"
                class="btn"
                @click="toDetail(item)"
                >查看详情</span
              >
              <img
                v-if="item.type === 2"
                class="cp-icon"
                :src="
                  require(`@/assets/imgs/xiameBankNewGuestsHaveGifts/cp.png`)
                "
                alt=""
              />
            </span>
            <span class="text3 van-ellipsis">{{ item.receiveStatusName }}</span>
          </li>
        </ul>
        <!-- </van-list> -->
      </div>
    </div>
  </div>
</template>
<script>
import { getRecordPages } from '@/api/xibWorkWeChatLottery.js'
import moment from 'moment'
// import MyHeader from './components/MyHeader.vue'
export default {
  components: {
    // MyHeader
  },
  data() {
    return {
      title: '厦门国际银行',
      loading: false,
      finished: false,
      list: [
      ]
    }
  },
  created() {
    if (sessionStorage.getItem('xibWorkWeChatLotteryToken')) {
      this.myPrize()
    } else {
      this.$router.replace('/XiameBankNewGuestsHaveGifts')
    }
  },
  methods: {

    myPrize() {
      getRecordPages({}).then(res => {
        const statusMap = {
          '0': '失败',
          '1': '已领取',
          '2': '已核销',
          '3': '已过期',
          '5': '未知',
        }
        res.data.forEach(i => {
          i.prizeName = i.type === 2 ? i.stockName : i.prizeName
          i.createTimeShow = moment(i.lotteryTime).format('YYYY-MM-DD HH:mm')
          i.receiveStatusName = statusMap[i.receiveStatus]  // 核对一下显示
          // "receiveStatus", value = "领取状态(0:失败；1：成功；2：核销；3：过期；4：待领取；5未知)")
        })
        this.list = res.data
      })
    },
    toDetail(item) {
      this.$router.push({
        path: '/XiameBankNewGuestsHaveGiftsDetail',
        query: {
          id: item.id,
        },
      })
    }
  },
}
</script>
<style lang="less" scoped>
.xiame-bank-new-guests-have-gifts-records {
  min-height: 100vh;
  font-size: 14px;
  // padding: 55px 14px 15px 14px;
  padding: 25px 14px 15px 14px;
  background: #cae9ff;
  box-sizing: border-box;
  position: relative;
  font-size: 0;

  .title {
    position: absolute;
    // top: 53px;
    top: 13px;
    left: 50%;
    transform: translateX(-50%);
    width: 186px;
  }

  .content {
    // padding: 60px 15px 1px 15px;
    padding: 60px 15px 1px 15px;
    font-size: 12px;
    color: #3f3f47;
    // min-height: calc(100vh - 160px);
    min-height: calc(100vh - 120px);
    margin-top: -3px;
    background: #ffffff;
    box-shadow: 0px 3px 1px 0px rgba(255, 255, 255, 0.65);
    border-radius: 15px;
    font-size: 13px;
    color: #000000;
    line-height: 20px;
    li {
      padding: 10px 0;
    }
    .text1 {
      width: 30%;
    }
    .text2 {
      width: 50%;
      line-height: 1.2;
      position: relative;
      .cp-icon {
        position: absolute;
        top: -6px;
        right: 0;
        width: 25px;
      }
    }
    .text3 {
      width: 20%;
    }
    .btn {
      margin: auto;
      width: 71px;
      height: 20px;
      border-radius: 10px;
      border: 1px solid #0065d9;
      font-size: 11px;
      color: #0065d9;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .header {
    background: #ddf1ff;
    border-radius: 10px;
    font-size: 14px;
    color: #014faa;
    line-height: 2.4;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;

    span {
      display: inline-block;
    }
  }

  .list {
    height: calc(100vh - 230px);
    overflow: auto;
    font-size: 12px;
    text-align: center;
    li {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // padding-left: 25px;
      font-size: 12px;
      border-bottom: 1px solid #e6e6e6;
    }

    span {
      display: inline-block;
    }

    .text1 {
      color: #999999;
      line-height: 1.2;
    }

    .text2 {
      color: #000000;
    }
    .text3 {
      color: #0065d9;
    }
  }
  /deep/ .van-list__finished-text,
  .van-loading__text {
    font-size: 12px;
  }
}
</style>
